import { withFieldConfigLayoutTabs } from "../components/withFieldConfigLayoutTabs.js";
import "react";
import { Checkbox, FormLayout, ListCreator, Text } from "@therms/atalaya";
import { jsx, jsxs } from "react/jsx-runtime";
//#region src/modules/FormBuilder/components/Fields/Select/Config.tsx
var SelectFieldConfig = withFieldConfigLayoutTabs(({ config, layoutType, setMultipleOptionsKeys, setOptions, setOptionsKey }) => {
	const optionsList = config.options.options || [];
	if (layoutType === "Display") return /* @__PURE__ */ jsx(FormLayout, {
		space: "sm",
		children: /* @__PURE__ */ jsx(Text, {
			onChangeValue: (value) => setOptionsKey("displayLabel", value),
			label: "Label",
			value: config.options.displayLabel
		})
	});
	return /* @__PURE__ */ jsx("div", { children: /* @__PURE__ */ jsxs(FormLayout, {
		space: "sm",
		children: [
			/* @__PURE__ */ jsx(Text, {
				onChangeValue: (value) => {
					if (config.options.displayLabel === config.options.formLabel) setMultipleOptionsKeys([["formLabel", value], ["displayLabel", value]]);
					else setOptionsKey("formLabel", value);
				},
				label: "Label",
				value: config.options.formLabel
			}),
			/* @__PURE__ */ jsx(Text, {
				onChangeValue: (value) => setOptionsKey("subText", value),
				label: "Sub Text",
				value: config.options.subText
			}),
			/* @__PURE__ */ jsx(Checkbox, {
				active: !!config.options.required,
				label: "Required",
				onChangeValue: (active) => setOptionsKey("required", active),
				subText: "Make this a required field"
			}),
			/* @__PURE__ */ jsx(Checkbox, {
				active: !!config.options.multi,
				label: "Allow multi-select",
				onChangeValue: (active) => setOptionsKey("multi", active),
				subText: "Allow the user to select multiple options"
			}),
			/* @__PURE__ */ jsx(Checkbox, {
				active: !!config.options.allowCustomTags,
				label: "Allow custom options",
				onChangeValue: (active) => setOptionsKey("allowCustomTags", active),
				subText: "Allow the user to enter options that do not already exist in the list"
			}),
			/* @__PURE__ */ jsx(ListCreator, {
				label: "Options",
				onAddOption: (option) => {
					setOptionsKey("options", [...optionsList, option]);
				},
				onOptionsOrderChange: (list) => {
					setOptionsKey("options", list);
				},
				onRemoveOption: (option) => {
					setOptionsKey("options", optionsList.filter((opt) => opt.label !== option.label));
				},
				options: optionsList
			})
		]
	}) });
});
//#endregion
export { SelectFieldConfig };

//# sourceMappingURL=Config.js.map